 <div class="grid">
   <div class="col-12 md:col-3 lg:col-3 sm:col-3">
      <label class="filter" for="product" style="color: #e20b50;">Product Name</label>
      <p-dropdown [filter]="true" pTooltip="Select Product Name" [options]="productList"  id="productid" name="productid"
      [(ngModel)]="filterinput.productid"  [showClear]="true" placeholder="Select" title="Select Product Name" 
       optionLabel="labelname" optionValue="value" styleClass="fixed-width-dropdown-filter" [resetFilterOnHide]="true"
      (onChange)="onFilterSelect(filterinput)" inputId="productid" [pTooltip]="getproductTooltip()"></p-dropdown>
</div>

 <div class="col-12 md:col-3 lg:col-3 sm:col-3">

  <label class="filter" for="user" style="color: #e20b50;">Scheduler Name</label>
    <p-dropdown [filter]="true" pTooltip="Select Scheduler Name" [options]="schedulerList"  id="schedulerid" name="schedulerid"
    [(ngModel)]="filterinput.schedulerid"  [showClear]="true" placeholder="Select" title="Select schedule Name"
     optionLabel="labelname" optionValue="value" styleClass="fixed-width-dropdown-filter" [resetFilterOnHide]="true"
     (onChange)="onFilterSelect(filterinput)" inputId="schedulerid" [pTooltip]="getschedulerTooltip()"></p-dropdown>
</div>
  <div class="col-12 md:col-3 lg:col-3 sm:col-3">
      <label class="filter" for="status" style="color: #e20b50;">Status</label>
      <p-dropdown [filter]="true" pTooltip="Select Status" [options]="statusList"  id="status" name="status"
      [(ngModel)]="filterinput.status"  [showClear]="true" placeholder="Select" title="Select Status"
       optionLabel="labelname" optionValue="value" styleClass="fixed-width-dropdown-filter" [resetFilterOnHide]="true"
      (onChange)="onFilterSelect(filterinput)" inputId="status" [pTooltip]="getstatusTooltip()"></p-dropdown>
</div></div>
<div class="grid">
  <div class="col-12 md:col-3 lg:col-3 sm:col-6">
     <label class="filter" for="type" style="color: #e20b50;">Scheduler Type</label>
    <p-dropdown [filter]="true" pTooltip="Select Scheduler Type" [options]="typeList"  id="schedulertype" name="schedulertype"
    [(ngModel)]="filterinput.schedulertype"  [showClear]="true" placeholder="Select" title="Select schedule Type"
     optionLabel="labelname" optionValue="value" styleClass="fixed-width-dropdown-filter" [resetFilterOnHide]="true"
    (onChange)="onFilterSelect(filterinput)" inputId="schedulertype" [pTooltip]="gettypeTooltip()"></p-dropdown>
</div>
  <div class="col-12 md:col-2 lg:col-2 sm:col-2" >
    <label  class="filter" for="fromdate" style="color: #e20b50;">From Date</label>
    <p-calendar [showIcon]="true" [pTooltip]="" [(ngModel)]="filterinput.from_date" placeholder="Choose Date"
       dateFormat="dd-M-yy" (onSelect)="getdates(filterinput)" [clearButtonStyleClass]="'hideClearButton'"
      inputId="from_date"  [readonlyInput]="true" [showButtonBar]="true" appendTo="body" [showOtherMonths]="true" [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
                      <div class="error-space" style="margin-top: 5px;">
                  <span *ngIf="fromdateerrorDisplay" style="color: red;">From date is required</span></div>
    </div>
  <div class="col-12 md:col-2 lg:col-2 sm:col-2" >
    <label class="filter" for="todate" style="color: #e20b50;">To Date</label>
    <p-calendar [pTooltip]="" [showIcon]="true" [(ngModel)]="filterinput.to_date" placeholder="Choose Date"
       dateFormat="dd-M-yy" (onSelect)="getdates(filterinput)" (onClearClick)="onclear(filterinput)" [clearButtonStyleClass]="'hideClearButton'"
      inputId="to_date"  [readonlyInput]="true" [showButtonBar]="true" appendTo="body" [showOtherMonths]="true" [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
                    <div class="error-space" style="margin-top: 5px;">
                  <span *ngIf="errorDIsplay" style="color: red;">To date should be greater than from date</span>
            <span *ngIf="todateerrorDIsplay" style="color: red;">To date is required</span>    </div>
  </div>
   <!-- <p-button  [style.marginTop.px]="3" [style.marginLeft.px]="1" styleClass="refreshbtn" severity="success" (click)="refreshFilters()" >
    <i class="fa fa-refresh" aria-hidden="true"></i>
 </p-button> -->
   <p-button  [style.marginTop.px]="4" styleClass="refreshbtn reset-btn" severity="success" pTooltip="Reset" (click)="refreshFilters()" >
    <i class="fa fa-refresh" aria-hidden="true"></i>
   </p-button>
</div>
  <!-- <div class="col-12 md:col-3 lg:col-3 sm:col-3">
<p-calendar (onSelect)="getdates(filterinput)" inputId="from_date" appendTo="body" dateFormat="dd-MM-yy"
placeholder="DD-MMM-YYYY" [showIcon]="true"></p-calendar>
</div>

    <div class="col-12 md:col-3 lg:col-3 sm:col-3">
<p-calendar (onSelect)="getdates(filterinput)" inputId="to_date" appendTo="body" dateFormat="dd-MM-yy"
placeholder="DD-MMM-YYYY" [showIcon]="true"></p-calendar>
</div> -->
